import { render, staticRenderFns } from "./ShibouDoukishoEdit.vue?vue&type=template&id=9dc86456&scoped=true"
import script from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
export * from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShibouDoukishoEdit.vue?vue&type=style&index=0&id=9dc86456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc86456",
  null
  
)

export default component.exports